import React, { Component } from "react";
import { connect } from "react-redux";
import { setToken, setUser, setSignupModalStatus } from "../../actions";

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.openSigninModalPopup("signin");
    this.props.history.push("/", { provider: 'signup_verification_mail' });
  }

  openSigninModalPopup = (formName) => {
    this.props.setSignupModalStatus(true, formName);
  };

  render() {
    return (
      <React.Fragment>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(SignIn)
};
